import React, { useState, useEffect } from "react";
import { X } from "lucide-react";

const CookieBanner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("cookieChoice")) {
      const t = setTimeout(() => setShow(true), 1200);
      return () => clearTimeout(t);
    }
     
  }, []);

  const choose = (choice) => {
    localStorage.setItem("cookieChoice", choice);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 w-[92vw] max-w-sm bg-white rounded-xl shadow-2xl border border-neutral-200 p-5 animate-fade-up">
      <div className="flex items-start justify-between">
        <p className="text-xs font-semibold tracking-widest text-neutral-500 uppercase">
          Confidentialité
        </p>
        <button onClick={() => choose("dismiss")} className="text-neutral-400 hover:text-neutral-700">
          <X size={16} />
        </button>
      </div>
      <p className="mt-3 text-sm text-neutral-600 leading-relaxed">
        Nous utilisons uniquement des cookies techniques pour le bon
        fonctionnement du site. Aucun cookie publicitaire ni traceur tiers.
      </p>
      <div className="mt-4 flex gap-3">
        <button
          onClick={() => choose("accept")}
          className="bg-brand hover:bg-brand-dark text-white text-sm font-semibold px-4 py-2 rounded-md transition-colors"
        >
          J'ai compris
        </button>
        <button
          onClick={() => choose("refuse")}
          className="text-neutral-600 hover:text-neutral-900 text-sm font-semibold px-4 py-2 rounded-md border border-neutral-300 transition-colors"
        >
          Refuser
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
